import { PageContext } from './../types/pageContext';
import { getLanguagesFromPath } from './../utils/localization';
/**
 * A hook used to get the languages available for a landing page for SEO Link generation
 */

import { useMemo } from 'react';

export const useSEOLanguages = (pageContext: PageContext) => {
  const {
    i18n: { originalPath },
  } = pageContext;

  const languages = useMemo(() => {
    const languagesFromPath = getLanguagesFromPath(originalPath);
    return languagesFromPath?.map(language => ({
      language,
      url: originalPath,
    }));
  }, []);

  return languages;
};
